import { MouseEvent, ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Analytics from 'src/helpers/Analytics';
import { useLocationSearch } from 'src/helpers/hooks/useLocationSearch';
import { getPurchasePolicyAdditionalData } from 'src/redux/selectors/purchasePolicy';

interface AnalyticsTrackerProviderProps {
  children: ReactNode;
}

export function AnalyticsTrackerProvider({
  children,
}: AnalyticsTrackerProviderProps) {
  const location = useLocation();
  const getUrlWithQueryParams = useLocationSearch();
  const purchasePolicyAdditionalData = useSelector(
    getPurchasePolicyAdditionalData,
  );

  useEffect(() => {
    const url = getUrlWithQueryParams(location.pathname);
    Analytics.trackCurrentPage(url, purchasePolicyAdditionalData.id);

    /**
     * Disabling the eslint rule because we trigger the effect
     * only when the route changes.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  function trackOnClick(event: MouseEvent<HTMLDivElement>) {
    const eventTarget = event.target as HTMLFormElement;

    if (eventTarget.form) {
      if (eventTarget?.nodeName === 'INPUT') {
        Analytics.trackEvent(`${eventTarget.form.name} FormInteractions`, {
          input: eventTarget.name,
          value: eventTarget.value,
        });
      }
    }
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      onClick={trackOnClick}
      className="shell_container"
      id="shell_container"
    >
      {children}
    </div>
  );
}
